import { type ReactNode, useMemo } from 'react';

import { getInitials } from '../../../utils/get-initials';

export const useGetInitials = (children: ReactNode, singleCharacterOnly = false) => {
  const initials = useMemo(() => {
    if (typeof children === 'string') {
      return getInitials(children, singleCharacterOnly);
    }

    return '';
  }, [children, singleCharacterOnly]);

  return initials;
};
